const Filter = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 17H4M20 17h-2" stroke="#000" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        <path d="M15 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 7H4M20 7h-7" stroke="#000" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        <path d="M10 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" stroke="#000" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default Filter;